import { render, staticRenderFns } from "./kanbanboard.vue?vue&type=template&id=d4ce12dc&"
import script from "./kanbanboard.vue?vue&type=script&lang=js&"
export * from "./kanbanboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports